// extracted by mini-css-extract-plugin
module.exports = {"base":"ErrorContent_base__3ak3f"};